module.exports = __webpack_public_path__ + "static/media/capstone_permissions.f284da4a.yaml";